import React, { useEffect, useState } from "react";
import reportAPI from "../../api/reportAPI";
import { LoadingSpinner, ErrorMessage } from "../../components/common/ErrorComponents";

const SearchEffectivenessWidget = ({ days = 30, limit = 10 }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await reportAPI.getSearchEffectiveness(days, limit);
        setData(response);
      } catch (err) {
        setError("Failed to load search effectiveness data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [days, limit]);

  if (loading) return <LoadingSpinner message="Loading search effectiveness..." />;
  if (error) return <ErrorMessage message={error} />;

  return (
    <div className="dashboard-widget">
      <p><strong className="mb-2">Search effectiveness</strong></p>
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Query</th>
            <th>Total</th>
            <th>Success</th>
            <th>Success Rate</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td>{item.query}</td>
              <td>{item.total}</td>
              <td>{item.success}</td>
              <td>{(item.success_rate * 100).toFixed(1)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SearchEffectivenessWidget;
